export default __webpack_public_path__ + "static/media/daniel.7efec292.webp";